import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useDeleteTitle } from '../../../../services/hooks/Titles/useDeleteTitle';
import { useState } from 'react';
import { ITitlesProps } from '../../../../services/hooks/Titles/useGetTitlesTopicsData';
import { TextXS } from '../../../../components/Text/Index';
import { IoTrash } from 'react-icons/io5';

interface IOwnProps {
  refetch: () => void;
  title: ITitlesProps;
}

const FormDeleteTitleButton: React.FC<IOwnProps> = ({ refetch, title }) => {
  const [confirmText, setConfirmText] = useState('');
  const [titleProps, setTitleProps] = useState<ITitlesProps | undefined>(undefined);
  const deleteTitle = useDeleteTitle();
  const toast = useToast();
  const modalDelete = useDisclosure();

  const requestDeleteTitle = (titleId: string) => {
    deleteTitle
      .mutateAsync({ titleId: titleId })
      .then(() => {
        toast({
          title: 'Sucesso',
          description: 'Título excluído com sucesso',
          status: 'success',
          duration: 2000,
          isClosable: true,
        });
        modalDelete.onClose();
        refetch();
        setConfirmText('');
      })
      .catch(() => {
        toast({
          title: 'Erro',
          description: 'Erro na exclusão do título',
          status: 'warning',
          duration: 2000,
          isClosable: true,
        });
      });
  };

  return (
    <>
      <Modal
        isOpen={modalDelete.isOpen}
        onClose={() => {
          modalDelete.onClose();
          setTitleProps(undefined);
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent pb={10} maxW={['80%', '80%', '80%', '40%', '40%']} maxH="none">
          <ModalHeader textAlign="center">Remover arquivo</ModalHeader>
          <ModalCloseButton />

          <ModalBody display="flex" flexDir="column" gap={1}>
            <Stack>
              <Stack>
                <TextXS color="red.600" fontWeight="bold">
                  Atenção: esta ação é irreversível!
                </TextXS>
                <TextXS>
                  Ao prosseguir, este arquivo será excluído permanentemente do sistema. Certifique-se de que realmente
                  deseja continuar com esta operação.
                </TextXS>
              </Stack>

              <TextXS fontWeight="bold" mt={2}>
                Para confirmar, digite <span style={{ color: 'red' }}>remover</span> abaixo:
              </TextXS>
              <Input
                placeholder='Digite "remover" para confirmar'
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                size="sm"
              />

              <Button
                onClick={() => requestDeleteTitle(titleProps?.id || '')}
                colorScheme="red"
                isDisabled={confirmText !== 'remover'}
              >
                Remover arquivo
              </Button>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>

      <Button
        p={0}
        size={'sm'}
        onClick={() => {
          setTitleProps(title);
          modalDelete.onOpen();
        }}
        colorScheme="red"
      >
        <Flex gap={1}>
          <IoTrash />
          Remover arquivo
        </Flex>
      </Button>
    </>
  );
};

export default FormDeleteTitleButton;
